import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "empty-license-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "empty-license-page__image" }, null, -1)
const _hoisted_3 = { class: "empty-license-page__content control-l`" }
const _hoisted_4 = { class: "empty-license-page__buttons" }
const _hoisted_5 = { class: "label-m empty-license-page__contacts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NButtonSelect = _resolveComponent("NButtonSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('license.empty_license_description')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$t('license.contact_description')) + " ", 1),
        _createVNode(_component_NButton, {
          type: "link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickHandler(_ctx.$t('license.contact_email'))))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('license.contact_email')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_NButton, {
        type: "secondary",
        size: "big",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action', 'upload'))),
        class: "empty-license-page__accent-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('license.actions.upload_file')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_NButtonSelect, {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => _ctx.$emit('action', 'download_c2v_' + value)),
        items: _ctx.c2vItems,
        type: "secondary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('license.actions.download_c2v')), 1)
        ]),
        _: 1
      }, 8, ["items"])
    ])
  ]))
}